import { StandardEvents } from '@shopify/events';

/**
 * The Fidèle composer (product templates). <composer-live> wraps a block whose content depends on
 * the selected variant (the price line, the summary box). On a variant change Horizon fetches the
 * section again for the new variant; this element takes its new content from that HTML, the same
 * way Horizon's own price block updates, so every value comes from Liquid and nothing is computed
 * here: no total, no discount, no compare-at.
 */
class ComposerLive extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
    this.#section = null;
  }

  /** @param {any} event */
  #onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      ?.then((/** @type {any} */ result) => {
        const html = result?.detail?.html;
        if (!html || !this.dataset.blockId) return;
        const next = html.querySelector(`composer-live[data-block-id="${this.dataset.blockId}"]`);
        if (next instanceof HTMLElement) this.innerHTML = next.innerHTML;
      })
      .catch(() => {
        // Horizon reports its own errors.
      });
  };
}

if (!customElements.get('composer-live')) customElements.define('composer-live', ComposerLive);
